import axios from "axios";
import { BASE_URL } from "./constants";

export const getAccessToken = () => {
  return axios.post(`${BASE_URL}/getaccesstoken`);
};
